module.exports = __webpack_public_path__ + "img/Res_Mus_5kl.307a47aa.jpg";